import script from "./ListTags.vue?vue&type=script&setup=true&lang=js"
export * from "./ListTags.vue?vue&type=script&setup=true&lang=js"

import "./ListTags.vue?vue&type=style&index=0&id=71c85d3e&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71c85d3e"]])

export default __exports__